module.exports = __webpack_public_path__ + "media/unipod/about_pods_2-fa4e2044.jpg";